import { createSlice } from '@reduxjs/toolkit';
import { addExtraReducer } from '../../utils/addExtraReducer';
import initialState from './initialState';
import { ClearCigarRecipeForTooltipReducer, GetCigarRecipeForTooltipReducer } from './reducers';
import { GetCigarRecipeForTooltip } from './thunks';

export const slice = createSlice({
  name: 'cigarRecipeForTooltip',
  initialState,
  reducers: {
    ClearCigarRecipeForTooltip: ClearCigarRecipeForTooltipReducer,
  },
  extraReducers: (builder) => {
    addExtraReducer(builder, GetCigarRecipeForTooltip, GetCigarRecipeForTooltipReducer);
  },
});

export default slice.reducer;
